
import { Order, MenuItem, Reservation, AppSettings } from '../types';

export const getConciergeResponse = async (
  prompt: string, 
  context: { 
    orders: Order[], 
    menu: MenuItem[], 
    reservations: Reservation[],
    settings: AppSettings
  }
): Promise<string> => {
  const token = localStorage.getItem('spacesimple_token');
  if (!token) {
    return "認証が必要です。再度ログインしてください。";
  }

  const systemInstruction = `
    あなたは飲食店管理システム「SpaceSimple」のスマート・マネージャー・アシスタントです。
    ユーザーは店舗のオーナーやスタッフです。
    提供されたコンテキスト（現在の売上、メニュー、予約状況、設定）を元に、質問に答してください。
    
    【コンテキスト】
    - 店名: ${context.settings.storeName || 'SpaceSimple'}
    - 現在のメニュー: ${JSON.stringify(context.menu.filter(i => i.isActive))}
    - 最近の売上: ${JSON.stringify(context.orders.filter(o => !o.isDeleted).slice(0, 50))}
    - 予約状況: ${JSON.stringify(context.reservations.filter(r => r.status !== 'cancelled'))}
    
    【指示】
    1. 売上の集計、人気メニューの分析、予約の確認、メニュー提案などを行ってください。
    2. 回答は簡潔かつ具体的で、店舗運営に役立つアドバイスを含めてください。
    3. 口調は丁寧で、温かみのある（カフェのような）トーンで話してください。
    4. マークダウン形式で読みやすく整形してください。
  `;

  try {
    const res = await fetch('/api/ai-chat', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ prompt, systemInstruction })
    });

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return data.text || "申し訳ありません。回答を生成できませんでした。";
  } catch (error: any) {
    console.error("AI Proxy Error:", error);
    if (error.message.includes('API_KEY')) {
      return "Gemini APIキーが設定されていません。Cloudflare Pagesの設定を確認してください。";
    }
    return `エラーが発生しました: ${error.message}`;
  }
};
